'use strict';
import {GlobalEvents} from '../../core-utilities/enums/GlobalEvents';
import {initAuth, requestLogout} from '../actions';
import {getUserId} from '../reducers/state';
import {assignUserToModel} from '../../app/model/actions';
import LogRocket from 'logrocket';

export function AuthServiceProvider() {
  const pr_google = 'https://www.googleapis.com/auth/';
  const pr_googleScopes = [
    pr_google + 'plus.login', /* Authenticate with user's account and access the user's basic information */
    pr_google + 'drive.file', /* Full access to user's drive account. Only needed until unified storage solution is available. May use drive.file in production */
    pr_google + 'calendar',    /* Full access to user's calendar. Allows app to update user's schedule for job assignments. */
  ];

  this.$get = [
    '$exceptionHandler',
    '$injector',
    '$timeout',
    '$rootScope',
    '$location',
    '$ngRedux',
    'DeviceServices',
    'EventBus',
    '$firebaseAuth',
    'FirebaseUtil',
    'UserProfileService',
    'UserDomain',
    'AppBootstrapper',
    function (
      $exceptionHandler,
      $injector,
      $timeout,
      $rootScope,
      $location,
      $ngRedux,
      DeviceServices,
      EventBus,
      $firebaseAuth,
      FirebaseUtil,
      UserProfileService,
      UserDomain,
      AppBootstrapper,
    ) {
      // postConstruct
      AppBootstrapper.loaded().then(() => {
        $ngRedux.dispatch(initAuth());
      });

      const AuthService = {};
      // Used for initial router state resolves until we have a better solution
      let authCompleteDeferred = Promise.defer();
      // HACK: This is a hacky workaround managing async state. Needs work
      let firebaseAuthenticatedDeferred = Promise.defer();

      const firebase = FirebaseUtil.firebaseRef();
      const firebaseAuth = $firebaseAuth(firebase);

      let currentUser = null;

      AuthService.initAuthComplete = initAuthComplete;
      /**
       * @return {?string}
       * @deprecated
       */
      AuthService.getUserId = getUserIdFromRedux;
      AuthService.getUserIdOnAuth = getUserIdOnAuth;
      AuthService.getCurrentUser = getCurrentUser;
      AuthService.getCurrentUserSync = getCurrentUserSync;
      AuthService.logout = logout;
      AuthService.userLoaded = userLoaded;
      AuthService.onFirebaseAuth = onFirebaseAuth;
      AuthService.onInitAuthComplete = onInitAuthComplete;
      AuthService._withUser = _withUser;

      function initAuthComplete() {
        return authCompleteDeferred.promise;
      }

      /**
       *
       * @return {?string}
       * @deprecated
       */
      function getUserIdFromRedux() {
        return getUserId($ngRedux.getState());
      }

      function getUserIdOnAuth() {
        return firebaseAuthenticatedDeferred.promise.then(function () {
          return AuthService.getUserId();
        });
      }

      function getCurrentUser() {
        return getUserIdOnAuth().then(function (userId) {
          // console.log('AuthService.getCurrentUser', userId);
          return UserDomain.$get(userId).then(function (user) {
            currentUser = user; // HACK: patches a race condition when the AngularFire $onAuth callback may be called AFTER $waitForAuth() resolves
            return user;
          });
        });
      }

      /**
       * TODO(redux): replace with redux store access
       * Do not use immediately after login.
       * @returns {*}
       */
      function getCurrentUserSync() {
        return currentUser;
      }

      // TODO(redux): update this. we will no longer use the angular fire auth wrapper
      function userLoaded() {
        return firebaseAuth.$requireAuth();
      }

      // TODO(redux): do we need this?
      function onFirebaseAuth(authData) {
        if (authData) {
          firebaseAuthenticatedDeferred.resolve();
          firebaseAuthenticatedDeferred = Promise.defer(); // in case a previous version was already rejected.
          firebaseAuthenticatedDeferred.resolve();

          EventBus.broadcast(GlobalEvents.UserChanged, {
            id: authData.uid,
            value: authData,
          });
        } else {
          // console.log('AuthService.$onAuth:no user found');
          firebaseAuthenticatedDeferred.reject();

          // TODO: determine requirements to deal with auth in cordova container
          // window.cookies.clear(function() { console.log('Cookies cleared!'); });

          EventBus.broadcast(GlobalEvents.UserChanged);
        }
      }

      /**
       * @param {?Error} err
       * @param {?String} userId
       */
      function onInitAuthComplete(err, userId) {
        if (!authCompleteDeferred.promise.isPending()) {
          // router view resolves need the latest auth state so we are resetting the deferred
          authCompleteDeferred = Promise.defer();
        }

        if (err) {
          authCompleteDeferred.reject(err);
        } else if (userId) {
          try {
            LogRocket.identify(userId);
          } catch (e) {
            // Do nothing
          }

          authCompleteDeferred.resolve(userId);
        } else {
          authCompleteDeferred.reject(new Error('Failed to authenticate'));
        }
      }

      // TODO(redux): do we need this?
      function _withUser(user) {
        const $ngRedux = $injector.get('$ngRedux');
        $ngRedux.dispatch(assignUserToModel(user));

        if (user) {
          // console.log('_withUser:found', user);
          currentUser = user;
          // console.log('assigning current user:', currentUser);

          EventBus.broadcast(GlobalEvents.UserAvailable, user);
        }
      }

      function logout() {
        $ngRedux.dispatch(requestLogout());
      }

      return AuthService;
    }];
}



// WEBPACK FOOTER //
// ./src/js/auth/services/AuthService.js